import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import useAppStore from "@/context/store";
import parseSystemMsg from "@/utils/parseSystemMsg";
import useRequest from "@/utils/useReq";
import { Button, notification } from "antd";
import { useState } from "react";
import { ChatModal } from ".";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";
import { CONVERSATION_TYPE } from "./viewModel";

/**
 * 系统通知
 */
export default function SystemNotify() {
  const { headerHeight, dmUnread, latestSystemDM, config } = useAppStore(
    ({ headerHeight, dmUnread, latestSystemDM, config }) => ({
      headerHeight,
      dmUnread,
      latestSystemDM,
      config,
    })
  );

  const [visible, setVisibile] = useState(false);

  useRequest(
    async () => {
      // 存在未读系统私信，则进行提示
      if (+dmUnread?.unread_system_dm && latestSystemDM) {
        const closeHistory = localStorage.getItem(
          LOCAL_STORAGE_KEY["HB_NOTIFICATION_SYSTEM_DM"]
        );

        const data = latestSystemDM;

        const parse = parseSystemMsg(data.message.text);

        if (closeHistory == data.message.system_dm_id) {
          return;
        }

        // 超过7天的消息不再提示
        if (
          Date.now() - data.message.created_at * 1000 >
          (config.systemDmExpire || 7) * 24 * 60 * 60 * 1000
        ) {
          return;
        }

        notification.open({
          key: data.message.system_dm_id,
          className: styles.notification,
          icon: <HBIcon type="ic_notifications" />,
          duration: null,
          top: headerHeight + 10,
          message: (
            <div
              className={styles.title}
              data-content-source="系统消息通知"
              data-gd-click="button_click"
              data-button-name="查看详情"
              onClick={() => {
                setVisibile(true);
                notification.close(data.message.system_dm_id);
              }}
              title={parse.title}
            >
              {parse.title}
            </div>
          ),
          description: (
            <>
              <div
                data-dialog-title={`系统消息通知-${data.message.system_dm_id}`}
                data-gd-expose="dialog_expose"
                className={styles.desc}
                style={parse.title ? {} : { marginRight: 24 }}
                onClick={() => {
                  setVisibile(true);
                  notification.close(data.message.system_dm_id);
                }}
              >
                {parse.desc}
              </div>
              <Button
                className={styles.btn}
                data-dialog-title={`系统消息通知-${data.message.system_dm_id}`}
                data-gd-click="dialog_action"
                data-button-name="查看详情"
                type="primary"
                size="small"
                onClick={() => {
                  setVisibile(true);
                  notification.close(data.message.system_dm_id);
                }}
              >
                查看详情
              </Button>
              <Button
                className={styles.btn}
                data-content-source="系统消息通知"
                data-gd-click="button_click"
                data-button-name="我知道了"
                size="small"
                onClick={() => {
                  notification.close(data.message.system_dm_id);
                  localStorage.setItem(
                    LOCAL_STORAGE_KEY["HB_NOTIFICATION_SYSTEM_DM"],
                    data.message.system_dm_id
                  );
                }}
              >
                我知道了
              </Button>
            </>
          ),
          closeIcon: <HBIcon type="ic_close" />,
          onClose() {
            localStorage.setItem(
              LOCAL_STORAGE_KEY["HB_NOTIFICATION_SYSTEM_DM"],
              data.message.system_dm_id
            );
          },
        });
      }
    },
    {
      refreshDeps: [latestSystemDM],
    }
  );

  return (
    <ChatModal
      visible={visible}
      onCancel={() => setVisibile(false)}
      targetUserId={CONVERSATION_TYPE.SYSTEM}
    />
  );
}
